export default __webpack_public_path__ + "static/media/condor.8a327e56.svg";